<template>
  <table-view ref="table" class="h-full"
    v-model="selected"
    :value-key="PayloadSingleId"
    :include-key="['idCliente', 'idTipo', 'VerTodoEstados']"
    :get-params-path="getParamsPathAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :filter-panel="FilterPanel"
    :route-name="routeName"
    :excel-name="excelName"
    :breadcrumb-name="breadcrumbName"
    :id-vista="idVista"
    :header-title="headerTitle"
    :header-icon="headerIcon"
    :vuexnamespace="vuexnamespace"
    :lista-acciones="getAccionesPosibles"
    :footer-acciones="footerAcciones"
    @executeAction="executeAction">
    <template slot="dialogs">
      <Dialog
        :title="$t('groups.delete_group')"
        :visible.sync="showModal"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <span :key="t" v-for="t in processMessageDeleteGroup" class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ t }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </Dialog>
      <Dialog
        :title="$t('configurations.unlink_statuses')"
        :visible.sync="showModalUnlinkStatuses"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkStatuses }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalUnlinkStatuses = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {unlinkStatusesHandler(); showModalUnlinkStatuses = false}"/>
          </div>
        </template>
      </Dialog>
      <Dialog
        :title="$t('configurations.link_statuses')"
        :visible.sync="showModalLinkStatuses"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <div 
          class="overflow-x-hidden"
          ref="containerSelect"
          :style="{'height':heightContainerSelect}"
        >
          <el-form
            ref="ruleForm"
          >
            <div class="lg:mb-2">
              <div ref="selectRefAgencies">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.status')}}</label>
                <el-form-item prop="tagNombre">
                  <base-el-select ref="statusesSelect" class="w-full" :options="listaStatuses" v-model="listaStatusesSelected" multiple filterable 
                    @visible-change="onExpand" @change="onChangeInput" @select-all="loading => loadingActionSelectStatuses = loading" @unselect-all="loading => loadingActionUnSelectStatuses = loading" />
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" v-if="isAllStatusesSelected" @click="$refs.statusesSelect.unselectAll()" mode="secondary-phantom-blue" :text="$t('app.unselect_all')" :disabled="isLoadingSelectStatuses" :loading="isLoadingSelectStatuses"/>
            <base-button class="w-full" v-if="!isAllStatusesSelected" :disabled="isLoadingSelectStatuses || isEmptyStatusesList" @click="$refs.statusesSelect.selectAll()" mode="secondary-phantom-blue" :text="$t('app.select_all')" :loading="isLoadingSelectStatuses"/>
            <div class="w-48"></div>
            <base-button class="w-full" @click="showModalLinkStatuses = false" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
              :loading="isLoadingSelectStatuses"
              :disabled="isLoadingSelectStatuses"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyLinkStatusesHandler(); showModalLinkStatuses = false}"
              :loading="isLoadingSelectStatuses"
              :disabled="isLoadingSelectStatuses"/>
          </div>
        </template>
      </Dialog>
      <Dialog
        :title="$t('users.unlink_users')"
        :visible.sync="showModalUnlinkUsers"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkUsers }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalUnlinkUsers = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {unlinkUsersHandler(); showModalUnlinkUsers = false}"/>
          </div>
        </template>
      </Dialog>
      <Dialog
        :title="$t('users.link_users')"
        :visible.sync="showModalLinkUsers"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <div 
          class="overflow-x-hidden"
          ref="containerSelect"
          :style="{'height':heightContainerSelect}"
        >
          <el-form
            ref="ruleForm"
          >
            <div class="lg:mb-2">
              <div ref="selectRefAgencies">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('users.header')}}</label>
                <el-form-item prop="tagNombre">
                  <base-el-select ref="usersSelect" class="w-full" :options="listaUsers" v-model="listaUsersSelected" multiple filterable 
                    @visible-change="onExpand" @change="onChangeInput" @select-all="loading => loadingActionSelectUsers = loading" @unselect-all="loading => loadingActionUnSelectUsers = loading" />
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" v-if="isAllUsersSelected" @click="$refs.usersSelect.unselectAll()" mode="secondary-phantom-blue" :text="$t('app.unselect_all')" :disabled="!isLoadedDataUsers || isLoadingSelectUsers" :loading="isLoadingSelectUsers"/>
            <base-button class="w-full" v-if="!isAllUsersSelected" :disabled="!isLoadedDataUsers || isLoadingSelectUsers || isEmptyUsersList" @click="$refs.usersSelect.selectAll()" mode="secondary-phantom-blue" :text="$t('app.select_all')" :loading="isLoadingSelectUsers"/>
            <div class="w-48"></div>
            <base-button class="w-full" @click="showModalLinkUsers = false" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
              :loading="isLoadingSelectUsers"
              :disabled="isLoadingSelectUsers"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyLinkUsersHandler(); showModalLinkUsers = false}"
              :loading="isLoadingSelectUsers"
              :disabled="isLoadingSelectUsers"/>
          </div>
        </template>
      </Dialog>

      <import-generic-dialog
        :secondaryTemplate="true"
        :activateSwitch1="true"
        :labelSwitch1="$t('imports.update_groups')" 
        :sizeLg="true"
        :dialogOpen="showModalImport" 
        @toggleDialog="toggleImport" 
        @applyDialog="applyImport"
        @downloadTemplate="downloadTemplate"
        :header="$t('imports.import_groups_header')" 
        />
    </template>
  </table-view>
</template>

<script>
import { bus } from '@/main'

import { i18n } from '@/i18n'
import TableView from '@/components/interfaces/TableView.vue'
import CustomFilter from '@/components/filters/GroupsFilter.vue'
import { Dialog } from 'element-ui'
import { getGroups } from '@/services/configurations/groups/getGroups'
import { downloadGroupsExcel } from '@/services/configurations/groups/downloadGroupsExcel'
import { deleteGroup } from '@/services/configurations/groups/deleteGroup'
import { linkGroupsToStatuses } from '@/services/configurations/groups/linkGroupsToStatuses'
import { unlinkGroupsToStatuses } from '@/services/configurations/groups/unlinkGroupsToStatuses'
import { getAllUsers } from '@/services/configurations/getAllUsers'
import { linkUsersGroupsMultiple } from '@/services/configurations/groups/linkUsersGroupsMultiple'
import { unlinkGroupsUsersMultiple } from '@/services/configurations/groups/unlinkGroupsUsersMultiple'

import ImportGenericDialog from '@/components/ImportGenericDialog.vue'
import { importGroups } from '@/services/configurations/imports/importGroups'
import { downloadTemplateGroups } from '@/services/configurations/imports/downloadTemplateGroups'
import { downloadExcelGroupsImportMode } from '@/services/companies/downloadExcelGroupsImportMode'

export default {
  name: 'groups-list-view',
  components: {
    TableView,
    Dialog,
    ImportGenericDialog,
  },
  data () {
    return {
      idVista: 45,
      FilterPanel: CustomFilter,
      vuexnamespace: 'groups',
      headerTitle: i18n.t('groups.header'),
      headerIcon: 'config',
      routeName: 'configurations/groups/details',
      excelName: `${i18n.t('groups.header').toLowerCase()}.xlsx`,
      breadcrumbName: 'Nombre',
      PayloadSingleId: 'IdGrupo',
      listaAcciones: [
        { IdAccion: 200, Descripcion: i18n.t('configurations.link_statuses'), icon: 'link' },
        { IdAccion: 201, Descripcion: i18n.t('configurations.unlink_statuses'), icon: 'unlink' },
        { IdAccion: 600, Descripcion: i18n.t('users.link_users'), icon: 'useradd' },
        { IdAccion: 601, Descripcion: i18n.t('configurations.unlink_users'), icon: 'userremove' },
        { IdAccion: 500, Descripcion: i18n.t('app.edit_fields'), icon: 'editpencil' },
        { IdAccion: 0, Descripcion: i18n.t('app.remove'), icon: 'trash' }
      ],
      processMessageUnlinkStatuses: i18n.t('app.unlink_all_entity_confirmation', { entity: i18n.t('app.statuses').toLowerCase(), from: i18n.t('groups.header').toLowerCase() }),
      processMessageUnlinkUsers: i18n.t('app.unlink_all_entity_confirmation', { entity: i18n.t('users.header').toLowerCase(), from: i18n.t('groups.header').toLowerCase() }),

      heightSelect: 0,
      heightInput: 35,
      // Import
      showModalImport: false,
      // Links
      listaStatusesSelected: [],
      showModalLinkStatuses: false,
      showModalUnlinkStatuses: false,
      showModal: false,
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionSelectStatuses: false,
      loadingActionUnSelectStatuses: false,

      showModalLinkUsers: false,
      showModalUnlinkUsers: false,
      listaUsers: [],
      listaUsersSelected: [],
      isLoadedDataUsers: false,
      selected: []
    }
  },
  computed: {
    footerAcciones () {
      return [
        // {
        //   disabled: !this.exportGroupsImportMode,
        //   text: i18n.t('groups.export_excel_import'),
        //   icon: 'excelxls', 
        //   handler: this.exportExcelGroupsImportMode
        // },
        {
          disabled: !this.hasModuleImportaciones,
          text: i18n.t('app.import'), 
          icon: 'import', 
          handler: this.toggleImport
        },
        {
          text: i18n.t('groups.new_group'), 
          icon: 'plus', 
          handler: this.goToNewGroup 
        }
      ]
    },
    exportGroupsImportMode () {
      if (this.role === 2) return true
      if (!this.hasSelected) return false
      const idCliente = this.selected[0].idCliente
      const idTipoGrupo = this.selected[0].idTipoGrupo
      if (this.selected.filter(x => x.idCliente === idCliente).length === this.selected.length &&
        this.selected.filter(x => x.idTipoGrupo === idTipoGrupo).length === this.selected.length &&
        this.selected.filter(x => x.idTipoGrupo === 1 || x.idTipoGrupo === 3 /* Sin Gestor NEOs ni Reparto */).length === 0) return true
      return false
    },
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasImportacionesModule']
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    listaStatuses: function () {
      return [...this.$store.getters['config/TIPOS_ESTADO'], ...this.$store.getters['config/TIPOS_ESTADO_RECEPCION']]
    },
    processMessageDeleteGroup () {
      return [i18n.t('groups.delete_selected_advice'), i18n.t('app.delete_selected_confirmation', { entity: i18n.t('groups.header').toLowerCase() })]
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isEmptyStatusesList: function () {
      return this.listaStatuses === undefined || this.listaStatuses === null || this.listaStatuses.length === 0
    },
    isEmptyUsersList: function () {
      return this.listaUsers === undefined || this.listaUsers === null || this.listaUsers.length === 0
    },
    isLoadingSelectStatuses: function () {
      return this.loadingActionSelectStatuses || this.loadingActionSelectStatuses
    },
    isLoadingSelectUsers: function () {
      return this.loadingActionSelectUsers || this.loadingActionSelectUsers
    },
    isAllStatusesSelected: function () {
      if (this.listaStatuses.length === this.listaStatusesSelected.length) return true
      else return false
    },
    isAllUsersSelected () {
      if (this.listaUsers.length === this.listaUsersSelected.length) return true
      else return false
    },
    getAccionesPosibles () {
      let listaAccionesFinal = this.listaAcciones.slice()
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        // Quitamos poder eliminar grupos pool y acciones de estados y editar campos
        if (this.selected.length !== this.selected.filter(x => x.idTipo !== 1).length) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 0)
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 200 && x.IdAccion !== 201)
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 500)
        }
        // Quitamos poder realizar acciones de gestión a grupos de reparto
        if (this.selected.length !== this.selected.filter(x => x.idTipo !== 3).length) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 200 && x.IdAccion !== 201)
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 600 && x.IdAccion !== 601)
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 500)
        } else {
          // Quitamos vinculaciones para usuarios y editar campos de diferentes clientes
          const idCliente = this.selected[0].idCliente
          if (this.selected.length !== this.selected.filter(x => x.idCliente === idCliente).length) {
            listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 200 && x.IdAccion !== 600)
            listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 500)
          }
          // Quitamos acciones con estados si el grupo puede ver todos los estados
          if (this.selected.length !== this.selected.filter(x => x.VerTodoEstados === false).length) {
            listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 200 && x.IdAccion !== 201)
          }
        }
      }
      return listaAccionesFinal
    },
    firstGroupSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) return this.selected[0].IdGrupo
      return 0
    }
  },
  watch: {
    showModalLinkUsers: async function (val, oldVal) {
      this.isLoadedData = false
      try {
        this.isLoadedDataUsers = false
        if (val === true) {
          const data = await getAllUsers({ idGrupo: this.firstGroupSelected })
          if (data.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
          } else {
            data.respuesta.forEach(row => {
              this.listaUsers.push({ value: row.IdUsuario, label: row.Usuario })
            })
          }
        } else {
          this.listaUsers = []
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.isLoadedData = true
        this.isLoadedDataUsers = true
      }
    },
  },
  created () {
  },
  mounted () {
  },
  methods: {
    toggleImport () {
      this.showModalImport = !this.showModalImport
    },
    applyImport: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importGroups(file, { idCliente: form.idCliente, actualizarGrupos: form.switch1 })
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImport() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplate: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateGroups()
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-importacion-grupos-gestion.xlsx')
        }
        // const responseReparto = await downloadTemplateGroupsReparto()
        // if (responseReparto.blnError === true) {
        //   this.doFeedback(responseReparto.msgError + ' [Código de error: ' + responseReparto.codError + ']')
        // } else {
        //   this.downloadBlob(responseReparto, 'plantilla-importacion-grupos-reparto.xlsx')
        // }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    exportExcelGroupsImportMode: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const payload = {}
      if (this.hasSelected) {
        payload.idGrupos = this.selected.map(x => x.IdGrupo)
      }
      try {
        const response = await downloadExcelGroupsImportMode(payload)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'grupos-formato-importacion.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    getParamsPathAux (data) {
      return { id: data.IdGrupo }
    },
    getParamsAux (data) {
      return {
        idGrupo: data.id ? data.id.value : null,
        nombre: data.name ? data.name.value : null,
        tipo: data.tipoGrupo ? data.tipoGrupo.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        VerTodoGrupos: data.verTodoGroups ? data.verTodoGroups.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        email: data.email ? data.email.value : null,
        numeroSMSGenerico: data.phone ? data.phone.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        enviarAvisosUsuarios: data.enviarAvisosUsuarios ? data.enviarAvisosUsuarios.value : null,
        EnUso: data.enUso ? data.enUso.value : null,
      }
    },
    getPagAux: async function (objOrder, params) {
      return await getGroups(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      try {
        return await downloadGroupsExcel(objOrder, params)
      } catch (error) {
        // this.doFeedback()
      }
    },
    goToNewGroup: function () {
      this.$router.push({ name: 'configurations/groups/details', params: { id: -1 } })
    },
    executeAction: async function ({ action, selected = [], event }) {
      if (selected.length) {
        if (action.IdAccion === 0) { // borrar
          this.deleteGroup()
        } else if (action.IdAccion === 201) { // Unink statuses
          this.unlinkStatuses()
        } else if (action.IdAccion === 200) { // Link statuses
          this.toggleDialogLinkStatuses()
        } else if (action.IdAccion === 601) { // Unink users
          this.unlinkUsers()
        } else if (action.IdAccion === 600) { // Link users
          this.toggleDialogLinkUsers()
        } else if (action.IdAccion === 500) { // Plantilla modo edicion
          this.templateEditModeHandler()
        } else {
          console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
        }
      }
    },
    selectionChange: function (selected = []) {
      this.selected = selected
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    applyLinkStatusesHandler: async function () {
      this.showModalLinkStatuses = false 
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idEstados: [], idGrupos: [] }
        payload.idEstados = this.listaStatusesSelected
        payload.idGrupos = this.selected.map(x => x.IdGrupo)
        const response = await linkGroupsToStatuses(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
        }
        this.listaStatusesSelected = []
        this.$refs.table.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyLinkUsersHandler: async function () {
      this.showModalLinkUsers = false 
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idUsuarios: [], idGrupos: [] }
        payload.idUsuarios = this.listaUsersSelected
        payload.idGrupos = this.selected.map(x => x.IdGrupo)
        const response = await linkUsersGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
        }
        this.listaUsersSelected = []
        this.$refs.table.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleDialogLinkStatuses: function () {
      if (this.showModalLinkStatuses && this.isLoadingSelectStatuses) return
      this.listaStatusesSelected = []
      this.showModalLinkStatuses= !this.showModalLinkStatuses
    },
    toggleDialogLinkUsers: function () {
      if (this.showModalLinkUsers && this.isLoadingSelectUsers) return
      this.listaUsersSelected = []
      this.showModalLinkUsers= !this.showModalLinkUsers
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    templateEditModeHandler () {
      const data = {
        groups: this.selected.map(x => x.IdGrupo)
      }
      this.$router.push({ name: 'configurations/template/groups', params: { data: data } })
    },
    deleteGroup: async function () {
      this.showModal = !this.showModal
    },
    unlinkStatuses: async function () {
      this.showModalUnlinkStatuses = !this.showModalUnlinkStatuses
    },
    unlinkUsers: async function () {
      this.showModalUnlinkUsers = !this.showModalUnlinkUsers
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idGrupos: []
        }
        for (const element of this.selected) {
          payload.idGrupos.push(element.IdGrupo)
        }
        const response = await deleteGroup(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.selected = []
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.$refs.table.applyFilters()
    },
    unlinkStatusesHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push(element.IdGrupo)
        }
        const response = await unlinkGroupsToStatuses(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.$refs.table.applyFilters()
    },
    unlinkUsersHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push(element.IdGrupo)
        }
        const response = await unlinkGroupsUsersMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.$refs.table.applyFilters()
    },
  },
}
</script>

<style scoped>

</style>
